export default {
  BASE_URL: 'content/ad/',
  api: [
    {
      name: 'categories',
      method: 'GET',
      desc: '获取广告分类',
      path: 'category'
    },
    {
      name: 'list',
      method: 'GET',
      desc: '获取广告列表',
      append: true,
      path: 'adListByCategory',
      params: {
        id: '',
        pageNum: 1,
        pageSize: 25
      }
    },
    {
      name: 'search',
      method: 'GET',
      desc: '关键字搜索广告',
      path: 'adListByKeyWord',
      params: {
        keyWord: '',
        category: ''
      }
    },
    {
      name: 'updateStatus',
      method: 'POST',
      desc: '更新广告',
      path: 'updateStatus',
      params: {
        id: '',
        isEnabled: false
      }
    },
    {
      name: 'detail',
      method: 'GET',
      desc: '广告详情',
      path: 'adDetail',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'delete',
      method: 'GET',
      desc: '删除广告',
      path: 'operate',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'add',
      method: 'POST',
      desc: '新增广告',
      path: 'operate',
      params: {
        category: '',
        sortNum: '',
        isEnabled: '',
        adUrl: '',
        remark: '',
        image: ''
      }
    },
    {
      name: 'edit',
      method: 'POST',
      desc: '编辑广告',
      path: 'operate',
      params: {
        id: '',
        category: '',
        sortNum: '',
        isEnabled: false,
        adUrl: '',
        remark: '',
        adName: '',
        image: [
          {
            adFileId: '',
            adType: ''
          }
        ]
      }
    },
    {
      name: 'arguments',
      method: 'GET',
      desc: '获取新增参数，主要是分类的',
      path: 'category',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'translation',
      method: 'GET',
      desc: '获取切换动画类型',
      path: 'category/action'
    },
    {
      name: 'updateType',
      method: 'POST',
      desc: '更新广告展示类型或切换类型',
      path: 'changeShowTypeAndAction'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/cms/ad.js